<template>
  <SideCard>
    <template v-for="(item, index) in statusCodes">
      <div class="d-flex justify-content-between align-items-center" :key="index">
        <router-link :to="$route.path.split('comments')[0] + 'comments/' + item.desc" exact-active-class="text-primary" class="py-2 px-3 link-gray">
          <i :class="[item.icon, 'me-2 align-middle']"></i> {{ item.text }}
        </router-link>
        <span class="text-muted me-2">({{ counts[item.title] }})</span>
      </div>
    </template>
  </SideCard>
</template>

<script>
import SideCard from '../../components/common/SideCard'
import commentDataProvider from '../../services/comment'
export default {
  props: ['route'],
  components: {
    SideCard,
  },
  methods: {
    getCommentCount(id, path) {
      return commentDataProvider
        .CountCommentStatus(id, path)
        .then((res) => {
          const response = res.data.data.output
          return response
        })
        .catch((error) => {})
    },

    getPackageCommentCount(id, path) {
      return commentDataProvider
        .CountPackageCommentStatus(id, path)
        .then((res) => {
          const response = res.data.data.output
          return response
        })
        .catch((error) => {})
    },
  },
  mounted() {
    console.log(this.$route.params.packageId, this.$route.params.courseId)
    this.$route.params.courseId
      ? this.getCommentCount(this.$route.params.courseId || this.$route.params.packageId, this.$route.params.courseId ? 'CountCommentStatus/' : 'CountCommentStatus/').then(
          (res) => {
            this.$data.counts = res
          },
        )
      : this.getPackageCommentCount(this.$route.params.packageId || this.$route.params.courseId, this.$route.params.packageId ? 'CountCommentStatus/' : 'CountCommentStatus/').then(
          (res) => {
            this.$data.counts = res
          },
        )
  },

  data() {
    return {
      counts: null,
      statusCodes: [
        {
          code: 0,
          title: 'all',
          desc: '',
          text: 'همه',
          icon: 'fal fa-comment',
        },
        {
          code: 1,
          title: 'waitingForApprove',
          desc: 'waiting',
          text: 'در انتظار تایید',
          icon: 'fa fa-hourglass',
        },
        {
          code: 2,
          title: 'approved',
          desc: 'approved',
          text: 'تایید شده',
          icon: 'fa fa-check',
        },
        {
          code: 3,
          title: 'failed',
          desc: 'failed',
          text: 'رد شده',
          icon: 'fa fa-trash-alt',
        },
      ],
    }
  },
}
</script>

<style scoped>
.link-gray {
  color: #74788d;
}
</style>
